Namespace 'Monitoring.Models.SocialContents.LinkedIn'

class Monitoring.Models.SocialContents.LinkedIn.LinkedInAuthor
  constructor: (linkedInAuthorBuilder) ->
    @id = linkedInAuthorBuilder.getId()
    @username = linkedInAuthorBuilder.getUsername()
    @name = linkedInAuthorBuilder.getName()
    @profilePictureUrl = linkedInAuthorBuilder.getProfilePictureUrl()

  getId: ->
    @id

  getUsername: ->
    @username

  getName: ->
    @name

  getProfilePictureUrl: ->
    @profilePictureUrl
